import axios from "axios";
import server_config from '../../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const updateUserNotifications = async (foi = null, apiToken = null, removeFromNotifcations, editor) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!foi) {
        console.log("no foi");
        return null;
    }
    console.log("CALLING SERVER with updateusernotifications")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'updateusernotifications',
            'notificationType': 'resourceupdatednotification',
            'apiToken': apiToken,
            'foi': foi,
            'remove': removeFromNotifcations,
            'watchaseditor': editor
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from updateusernotifications call");
    }).catch((error) => { console.log(error); });
}

const updateUserNotification = async (updatedNotification = null, apiToken = null) => {
    if (!updatedNotification) {
        console.log("no updatedNotification");
        return null;
    }
    if (apiToken) {
        console.log("CALLING SERVER with updateuserspecificnotification")
        return await axios({
            method: 'POST',
            url: fevir_node_server_address,
            timeout: 120000,
            data: {
                'functionid': 'updateuserspecificnotification',
                'apiToken': apiToken,
                "updatednotification": updatedNotification
            },
        }).then((resp) => {
            if (resp?.data) {
                return resp.data;
            }
            console.log("NO RESPONSE from updateuserspecificnotification call");
        }).catch((error) => { console.log(error); });
    } else {
        console.log("no apiToken");
        return null;
    }
}

const updateUserSpecificNotifications = async (notificationsState = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!notificationsState) {
        console.log("no notificationsState");
        return null;
    }
    console.log("CALLING SERVER with updateuserspecificnotifications")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'updateuserspecificnotifications',
            'apiToken': apiToken,
            "notifications": notificationsState
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from updateuserspecificnotifications call");
    }).catch((error) => { console.log(error); });
}

const getUserNotifications = async (apiToken) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getusernotifications")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getusernotifications',
            'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
            //resp.data = { success: true, notifications: notifications, numberunreadnotifications: #,
            //                numberunclearednotifications: # }
            //notifications is an array of objects with: 
            // { 
      //  classifier: "resource-updated",
      // message: "Resource title (FOI 27270) was updated.",
      //  target: "27270",
      //  time: "2025-07-21T10:16:48.666Z",
      //  timeString: "Mon, Jul 21, 2025, 6:16 AM",
      //  uncleared: true,
      //   unread: false,
      //   userid: 16,
      //    _id: "68710a8bed09b4f5828faa80"    
        //        }
        }
        console.log("NO RESPONSE from getusernotifications call");
    }).catch((error) => { console.log(error); });
}

const getUserNotificationNumbers = async (apiToken = null) => {
    console.log("CALLING SERVER with getusernotifications")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 30000,
        data: {
        'functionid': 'getusernotificationnumbers',
        'apiToken': apiToken
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getusernotifications call");
    }).catch((error) => { console.log(error); });

}

export default updateUserNotifications;
export { getUserNotifications, updateUserSpecificNotifications, updateUserNotification, getUserNotificationNumbers }